'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'multipleMax';
const MULTIPLE_MAX_ERROR = 'multipleMaxError';
y__namespace.addMethod(y__namespace.NumberSchema, name, function({ limits, allLimitsError }) {
    const sortedLimits = limits.toSorted((a, b)=>b.value - a.value);
    return this.test(function(item) {
        if (limits.length === 0) {
            return true;
        }
        const { createError, path } = this;
        for (const { value, error } of sortedLimits){
            if (!y__namespace.number().max(value).isValidSync(item)) {
                const message = allLimitsError !== undefined && value === sortedLimits[0].value ? allLimitsError : error ?? {
                    key: MULTIPLE_MAX_ERROR
                };
                return createError({
                    path,
                    type: name,
                    message
                });
            }
        }
        return true;
    });
});

exports.MULTIPLE_MAX_ERROR = MULTIPLE_MAX_ERROR;
//# sourceMappingURL=multipleMax.js.map
